var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showServicesWorker)?_c('services-worker',{attrs:{"baseUrl":_vm.baseUrl}}):_vm._e(),(_vm.showServicesCustomer)?_c('services-customer',{attrs:{"baseUrl":_vm.baseUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }